import { HttpResponse } from '@angular/common/http';

export class FileHelper {
  public static getBlobAndFilename(res: HttpResponse<Blob>): { blob: Blob; filename: string } {
    const headers = res.headers;
    const blob = res.body!;
    const contentDisposition = headers.get('Content-Disposition')!;
    let filename!: string;
    contentDisposition.split(';').forEach((x) => {
      const entry = x.trim();
      if (entry.startsWith('filename')) {
        filename = entry.split('=')[1];
        filename = filename.replace(/["]+/g, '');
        filename = decodeURI(filename);
      }
    });
    return { blob, filename };
  }

  public static getBlobAndFilenameAndFiletype(res: HttpResponse<Blob>): { blob: Blob; filename: string; filetype: string } {
    const headers = res.headers;
    const blob = res.body!;
    const contentDisposition = headers.get('Content-Disposition')!;
    let filename!: string;
    contentDisposition.split(';').forEach((x) => {
      const entry = x.trim();
      if (entry.startsWith('filename')) {
        filename = entry.split('=')[1];
        filename = filename.replace(/["]+/g, '');
        filename = decodeURI(filename);
      }
    });

    const contentType = headers.get('Content-Type')!;
    const filetype: string = contentType.split(';')[0];

    return { blob, filename, filetype };
  }

  public static getExtension(filename: string | null | undefined) {
    return (filename?.indexOf('.') as number) > 0 ? filename?.split('.')?.pop() : '';
  }
}
